<template>
  <div>
    <b-form-file
      :ref="uploadFileRef"
      :size="size"
      :multiple="multiple"
      :value="value"
      :browse-text="buttonText"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="''"
      @input="updateValue"
      :accept="accept">
      <template slot="file-name" slot-scope="{ names }">
        <b-badge variant="dark">{{ names[0] }}</b-badge>
        <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
        + {{ names.length - 1 }} mais arquivos
        </b-badge>
      </template>
    </b-form-file>
  </div>
</template>

<script>
import UploadFile from './js'
export default UploadFile
</script>

<style scoped>
@import './scss/uploadfile.scss';
</style>
